import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
export const TagSkeleton = (props) => {
    const width = props.width || '144px';
    const height = props.size === 'small' ? '24px' : '32px';
    return React.createElement(SkeletonShape, { variant: "rectangular", width: width, height: height });
};
//# sourceMappingURL=Tag.skeleton.mjs.mjs.map